import { CellProps } from 'react-table'
import { FormularioActionsCell } from './FormulariosActionsCell'
import {
  PlainHeader,
  sortableColumn,
  StackedCell,
  StatusBadge,
  StatusDot,
  TableColumn,
} from '../../../../../../components'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { FormularioList } from '../../core/_models'
import { TFunction } from '_metronic/i18n/Metronici18n'

export const formulariosColumns = (t: TFunction): ReadonlyArray<TableColumn<FormularioList>> => [
  // Descrição é a linha de apoio do nome (texto longo, truncado com tooltip).
  sortableColumn<FormularioList>({
    id: 'nome',
    useQueryRequest,
    fields: [
      { field: 'nome', label: t('cols.nome') },
      { field: 'descricao', label: t('cols.descricao'), sortable: false },
    ],
    Cell: ({ row }: CellProps<FormularioList>) => (
      <StackedCell primary={row.original.nome} secondary={row.original.descricao} />
    ),
  }),
  sortableColumn<FormularioList>({
    id: 'empresa.nomeFantasia',
    cellWidth: '260px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'empresa.nomeFantasia', label: t('empresa.label') }],
    Cell: ({ row }: CellProps<FormularioList>) => (
      <StackedCell primary={row.original.empresa?.nomeFantasia} />
    ),
  }),
  sortableColumn<FormularioList>({
    id: 'ativo',
    cellWidth: '128px',
    useQueryRequest,
    fields: [{ field: 'ativo', label: t('cols.status') }],
    Cell: ({ row }: CellProps<FormularioList>) => <StatusBadge active={row.original.ativo} />,
  }),
  // Bloqueado = em uso por protocolo vigente; vem calculado da listagem, sem ordenação no backend.
  {
    Header: () => <PlainHeader>{t('formularios.bloqueio.badge')}</PlainHeader>,
    id: 'bloqueado',
    cellWidth: '128px',
    Cell: ({ row }: CellProps<FormularioList>) =>
      row.original.bloqueado ? (
        <StatusDot label={t('common.yes')} tone='primary' />
      ) : (
        <StatusDot label={t('common.no')} tone='neutral' />
      ),
  },
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '132px',
    align: 'end',
    Cell: ({ row }: CellProps<FormularioList>) => (
      <FormularioActionsCell formulario={row.original} />
    ),
  },
]
